import { eventMap } from './event-map.js'

export const invokeEvent = (eventName, payload) => {
  return new Promise((resolve, reject) => {
    try {
      // 兼容直接传递事件名称
      const event = eventMap[eventName]
      if (!event) {
        reject({ errmsg: `所触发的事件${eventName}未注册` })
      }
      event(payload, resolve, reject)
    } catch (error) {
      reject(error)
    }
  })
}
